import React from 'react';

import { Phone, Music, Camera, Contacts } from '../icons';

import S from './Dock.module.css';

const Dock = ({ isLocked }) => {
  return (
    <div className={S.root} data-is-locked={isLocked.toString()}>
      <div className={S.dockIcon}>
        <Phone />
      </div>
      <div className={S.dockIcon}>
        <Contacts />
      </div>
      <div className={S.dockIcon}>
        <Camera />
      </div>
      <div className={S.dockIcon}>
        <Music />
      </div>
    </div>
  );
};

export default Dock;
